import { Component, h, Host, JSX, Prop } from "@stencil/core";
import { Tag } from "@phn/entities/content";

export type tagColor = "light" | "dark";

@Component({
  tag: "phn-model-tags",
  styleUrl: "model-tags.scss",
  scoped: true,
})
export class ModelTags {
  @Prop() modelTags: Tag[];

  @Prop() tagColor: tagColor = "light";

  // convenience map for better usability
  private pdsColorMap: Map<string, string> = new Map<string, string>([
    ["light", "background-base"],
    ["dark", "background-surface"],
  ]);

  // TODO implement compact labels if requested
  render(): JSX.Element {
    return (
      <Host role="list">
        {this.modelTags?.map((tag: Tag) => (
          <phn-p-tag
            role="listitem"
            class="tag"
            theme="light"
            color={this.pdsColorMap.get(this.tagColor)}
            key={tag.text}
          >
            {tag.text}
          </phn-p-tag>
        ))}
      </Host>
    );
  }
}
